import React, { ReactElement} from 'react';
import './blinkingElement.less';

export const BlinkingElement = (props: any): (ReactElement | null) => {
  const {children, color, className} = props;
  return (
    <div
      className={`blinking-element ${className || ''}`}
      style={{ '--blink-color': color } as React.CSSProperties}
    >
      {children}
    </div>
  );
};
